// extracted by mini-css-extract-plugin
module.exports = {"container":"ProjectsFilter_container__3vVz3","body":"ProjectsFilter_body__FzhvO","buttonsContainer":"ProjectsFilter_buttonsContainer__1igIx"};